export default __webpack_public_path__ + "static/media/geometricfloor.e76315d3.png";